const userAddressName = "/UserAddress";

export function operationService(http) {
    return {
        getAllLocations: () => {
            return http.post(userAddressName + "/GetAllUsersLocation")            
        },
        getLocation:async (userId) => {
            let params = {
                userId, 
            };
            return await http.post(userAddressName + "/GetUserAddressLocationAsync", params)
        },
        saveLocation: async (
            userId,
            fullAddress,
            address,
            city,
            country,
            county,
            district,
            neighbourhood,
            plaque,
            postalAddress,
            province,
            region,
            ruralDistrict,
            village,
            type,
            coordinateX,
            coordinateY) => {
            let parameters = {
                userId,
                fullAddress,
                address,
                city,
                country,
                county,
                district,
                neighbourhood,
                plaque,
                postalAddress,
                province,
                region,
                ruralDistrict,
                village,
                type,
                coordinateX,
                coordinateY
            };
            return await http.post(userAddressName + "/SaveUserAddressLocationAsync", parameters)
        }
    }
}
